export default "__VITE_ASSET__DmffGQ2S__"